import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Modal, Spin } from "antd";
import { getPresenceDetailsDay } from "./../actions/presenceDetailsDay";
import ModalComponent from "../../../components/modalComponent/ModalComponent";
import Spinner from "./../../stats/components/Spinner";
import MapModal from "./modals/mapModal";
import { PresenceModal } from "./modals/presenceModal";
import DayViewBadgeFactory from "./DayViewBadgeFactory";
import { withRouter } from "react-router-dom";
import { roles } from "./../../../configs/constants";
import { isEmpty } from "lodash";
import { handleError } from "../api/api";
import axios from "axios";
import { rejectVacation, validateVacation } from "../actions/presence";
import { getAbsenceTypes } from "./../../../redux/actions/absenceTypesActions";
import {
  updatePresenceAttendance,
  updatePresenceMealPackage,
  resetPresenceMealPackage,
  updatePresenceTrip,
  resetPresenceTrip,
  resetPresenceAttendance
} from "./../actions/presenceDetailsDay";
import { computeEventInfos, computeTypeOfHalfDay, get } from "../utils/utils";
import ValidateModalContent from "../../../components/presence/ValideModalContent";
import { VACATION_REQUEST_STATUS_LABELS } from "../../../configs/constants";
import { usePresenceChanges } from "./../../../hooks/usePresenceChanges";
import moment from "moment";
import ReactLoading from "react-loading";

import {
  computeGridEnds,
  convertMinutesToString,
  DEFAULT_END_DAY_HOUR,
  DEFAULT_START_DAY_HOUR
} from "../utils/date.utils";
import { TextDuration, TextLabelData } from "../components/TextDuration";
import ConfirmButton from "../../../components/buttons/ConfirmButton";
import { getPresenceDataOfTheDay } from "../actions/presenceDetailsWeek";

const baseapi = process.env.REACT_APP_API + "/api";
export const ProcessMealPackage = ({
  errorMsg = null,
  displayTitle = false,
  warning = false,
  didErrorOccured,
  mealPackageModalValue,
  setMealPackageModalValue,
  handleGrantMealPackage
}) => {
  const mealPackageTrueStyle = () =>
    mealPackageModalValue === true
      ? "cursor-pointer border bg-orange-500 bg-opacity-25 text-orange-500" +
        " font-bold border-orange-500 px-10 py-2 rounded-full mr-6"
      : "cursor-pointer px-10 py-2 border border-gray-600 rounded-full mr-6";
  const mealPackageFalseStyle = () =>
    mealPackageModalValue === false
      ? "cursor-pointer border bg-orange-500 bg-opacity-25 text-orange-500 font-bold" +
        " border-orange-500 px-10 py-2 rounded-full"
      : "cursor-pointer px-10 py-2 border border-gray-600 rounded-full";

  return (
    <div>
      {didErrorOccured && (
        <div className="font-bold text-red-400 mb-8">
          Une erreur est survenue dans la requête.
          <div className="text-red-400 mt-2">{errorMsg}</div>
        </div>
      )}
      <div className="flex items-center justify-center">
        {displayTitle && <div className="font-bold text-xl mr-12">Forfait repas :</div>}
        <div onClick={() => setMealPackageModalValue(true)} className={mealPackageTrueStyle()}>
          Oui
        </div>
        <div onClick={() => setMealPackageModalValue(false)} className={mealPackageFalseStyle()}>
          Non
        </div>
      </div>
      {warning && (
        <div className="font-bold text-red-400 mt-8">
          Attention : une note de frais "invitation" existe à cette date.
        </div>
      )}

      <div className="flex justify-end mt-8">
        <div className="pt-6 flex justify-end ml-12">
          <div className="ml-2">
            <ConfirmButton label={"Ok"} large={true} onClick={() => handleGrantMealPackage()} />
          </div>
        </div>
      </div>
    </div>
  );
};

const Grid = ({ begin = DEFAULT_START_DAY_HOUR, end = DEFAULT_END_DAY_HOUR }) => {
  const grid = [];
  for (let i = begin; i <= end; i++) {
    grid.push(<span key={i}>{`${i}h`}</span>);
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between"
      }}
    >
      {grid}
    </div>
  );
};

const DayRow = ({
  userDetailsRole,
  userRoleId,
  driverId,
  driverName,
  isMealPackageLoading,
  setMealPackageModalValue,
  setMealPackageSelected,
  day,
  index,
  openTripsModal,
  openPresenceModal,
  openMealPackageModal,
  badgeFactory,
  chartData,
  token
}) => {
  const mealPackageData = {
    begin: 7,
    computeDiffWithStateDate: date => {
      console.log("date ->", date);
    },
    computePositionPx: date => {
      console.log("date ->", date);
    },
    end: 20,
    updateBeginAndEndHour: (begin, end) => {
      console.log("begin : ", begin);
      console.log("end : ", end);
    }
  };

  const getNbTripsAfter8pm = () => {
    const trips = day.trips || [];
    const tripAfter8pm = trips.filter(trip => {
      const time = moment(trip.start_date).set("hour", 20);
      return moment(trip.start_date).isAfter(time);
    });
    return tripAfter8pm.length;
  };
  const nbTripsAfter8pm = getNbTripsAfter8pm();

  const getMealPackageStyle = mealPackage => {
    let styleMealPackage = "cursor-pointer";

    if (mealPackage && mealPackage[0]) {
      if (mealPackage[0].granted === true) {
        styleMealPackage += " border-green-400";
      } else if (mealPackage[0].granted === false) styleMealPackage += " border-red-500";
      if (mealPackage[0].validated === true) {
        if (mealPackage[0].granted === true) {
          styleMealPackage += " bg-green-400";
        } else styleMealPackage += " bg-red-500";
      }
    }
    return styleMealPackage;
  };
  const [isGetButtonShowing, setIsGetButtonShowing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <tr
      className={`h-48 ${
        moment(day.date_iso).isSame(moment(), "day") ? "hover:bg-red-100" : "hover:bg-gray-100"
      } text-gray-700 text-lg ${moment(day.date_iso).isSame(moment(), "day") ? "bg-red-200" : ""}`}
      key={index}
    >
      <td
        className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900 w-1/12 cursor-pointer"
        onClick={() => {
          openPresenceModal({
            index: index,
            attendances: day.attendances,
            title: day.date,
            pending_vacations: day.pending_vacations,
            visits: day.visits
          });
        }}
      >
        {day.date}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-500 w-2/12">
        <TextDuration
          label="Activité"
          duration={day.durations.activity}
          durationTotal={day.durations.activity + day.durations.trips}
        />
        <TextDuration
          label="Trajets"
          duration={day.durations.trips}
          durationTotal={day.durations.activity + day.durations.trips}
        />
        {/* pour assurer l'alignement vertical des badges */}
        <div className="flex">
          <span className="my-2 text-lg text-gray-700">Global : </span>
          <span className="my-2 mx-2 text-lg text-gray-700 font-bold">
            {convertMinutesToString(day.durations.activity + day.durations.trips)}
          </span>
        </div>
        <div className="flex">
          <span className="my-2 text-lg text-gray-700">Temps effectif : </span>
          <span className="my-2 mx-2 text-lg text-gray-700 font-bold">
            {convertMinutesToString(day.durations && Math.round(day.durations.working_duration).toFixed(2))}
          </span>
        </div>
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-500 w-1/12">
        <TextLabelData label={"Visites"} data={Array.isArray(day.visits) ? day.visits.length : 0} />
        <TextLabelData
          label={"Trajets"}
          data={`${Array.isArray(day.trips) ? day.trips.length : 0} ${
            nbTripsAfter8pm > 0 ? `(dont ${nbTripsAfter8pm} après 20h)` : ``
          }`}
        />
        <TextLabelData label={"Forfait repas"} data={get(["meal_packages", 0, "granted"], day) ? 1 : 0} />
      </td>
      <td className="px-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900 text-right w-2/3 relative">
        <div className="flex justify-between h-6">
          {chartData.activity[index] && chartData.activity[index].length > 0 ? (
            badgeFactory.buildBadgeObjects(chartData.activity[index], content => {
              const typeEvent = content.event_type_label || content.type_event || "";

              if (typeEvent.toLowerCase() === "visite") {
                window.open(`${window.location.origin}/visit/preview/${content._id}`, "_blank");
              }
            })
          ) : (
            <div className="h-6 py-1 mx-auto">Pas de visite</div>
          )}
        </div>
        <div className="flex justify-between h-16">
          {chartData.trips[index] && chartData.trips[index].length > 0 ? (
            badgeFactory
              .buildBadgeObjects(chartData.trips[index], params => openTripsModal({ ...params, index }))
              .map(badge => badge)
          ) : (
            <div className="h-6 py-1 mx-auto">
              {`${!isGetButtonShowing ? "Pas de trajet" : ""}  `}
              {!isGetButtonShowing && userRoleId <= roles.MANAGER && (
                <span onClick={() => setIsGetButtonShowing(true)}>( + )</span>
              )}
              {isGetButtonShowing && isLoading && <Spinner></Spinner>}
              {userRoleId === roles.ADMIN && isGetButtonShowing && !isLoading && (
                <span
                  className="inline-block mr-2 text-xs font-xs leading-6 text-center text-white uppercase transition bg-red-500 rounded shadow ripple hover:shadow-lg hover:bg-red-600 focus:outline-none cursor-pointer"
                  onClick={async () => {
                    try {
                      setIsLoading(true);
                      const response = await axios.post(
                        `${baseapi}/trips/updateday/?date=${moment(day.date_iso).format("YYYY-MM-DD")}`,
                        {},
                        {
                          headers: {
                            Authorization: token
                          }
                        }
                      );
                      const { data } = response;
                      Modal.warning({
                        title: "Attention",
                        content: `${data} trajet(s) récupéré(s), veuillez recharger la page pour les afficher.`
                      });
                    } catch (e) {
                      handleError(e);
                    }
                    setIsLoading(true);
                    setIsGetButtonShowing(false);
                  }}
                >
                  récupérer les trajets de tous les utilisateurs
                </span>
              )}
              {userRoleId <= roles.MANAGER && isGetButtonShowing && !isLoading && (
                <span
                  className="inline-block text-xs font-xs leading-6 text-center text-white uppercase transition bg-orange-500 rounded shadow ripple hover:shadow-lg hover:bg-red-600 focus:outline-none cursor-pointer"
                  onClick={async () => {
                    try {
                      setIsLoading(true);
                      const response = await axios.post(
                        `${baseapi}/trips/updateuserday/?date=${moment(day.date_iso).format("YYYY-MM-DD")}`,
                        { userId: driverId },
                        {
                          headers: {
                            Authorization: token
                          }
                        }
                      );
                      const { data } = response;
                      Modal.warning({
                        title: "Attention",
                        content: `${data} trajet(s) récupéré(s), veuillez recharger la page pour les afficher.`
                      });
                    } catch (e) {
                      handleError(e);
                    }
                    setIsLoading(false);
                    setIsGetButtonShowing(false);
                  }}
                >
                  récuperer les trajets du jour de {driverName}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="flex justify-between h-6">
          {/* {badgeFactory.buildBadgeObjects(chartData.presence[index], () =>
            openPresenceModal({
              attendances: day.attendances,
              title: day.date,
              pending_vacations: day.pending_vacations,
              visits: day.visits,
              index: index
            })
          )} */}
          {userDetailsRole === roles.TERRAIN && userRoleId < 4 && day.meal_packages && day.meal_packages[0] && (
            <div className="mealpackage flex items-center" style={{ marginLeft: "46%", marginTop: "-34px" }}>
              <div
                className={`border-2 flex justi
                y-center text-white rounded-full ${getMealPackageStyle(day ? day.meal_packages : null)}`}
                style={{ padding: "6px 15px", position: "absolute", left: "47%" }}
                onClick={() => {
                  setMealPackageModalValue(day.meal_packages[0].granted);
                  setMealPackageSelected(day.meal_packages);
                  openMealPackageModal({
                    index: index,
                    title: "Forfait repas"
                  });
                }}
              >
                {isMealPackageLoading ? (
                  <ReactLoading type="bubbles" color="#000" width="20px" height="15px" />
                ) : (
                  <img src="/img/restaurant.png" style={{ width: "15px" }} />
                )}
              </div>
            </div>
          )}
        </div>
        {badgeFactory.showCurrentTime(day.date_iso)}
      </td>
    </tr>
  );
};

const DayView = ({
  resetAttendanceErrors,
  resetTripErrors,
  updateTrip,
  resetMealPackageErrors,
  updateMealPackageErrors,
  updateMealPackage,
  updateAttendance,
  detailsDay,
  fetchDetailsDay,
  userDetailsRole,
  setUserDetailRole,
  userRoleId,
  userId,
  token,
  setUserName,
  userName,
  rangeDate,
  history,
  absenceTypes,
  getAbsenceTypes,
  accept,
  reject,
  selectedUserBalance,
  isLoading,
  getPresenceDataOfTheDay
}) => {
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorModalData, setErrorModalData] = useState(null);
  const [isMealPackageLoading, setIsMealPackageLoading] = useState(false);
  const [didErrorOccured, setDidErrorOccured] = useState(false);
  const [days, setDays] = useState([]);
  const [mealPackageSelected, setMealPackageSelected] = useState(null);
  const [mealPackageModalValue, setMealPackageModalValue] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedModalData, setSelectedModalData] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [filters, setFilters] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const _badgeFactory = new DayViewBadgeFactory(DEFAULT_START_DAY_HOUR, DEFAULT_END_DAY_HOUR);
  const [badgeFactory, setBadgeFactory] = useState(_badgeFactory);
  const [selectedDayData, setSelectedDayData] = useState(null);
  // const [isLoading, setIsLoading] = useState(false); // solution temporaire car casse l'UX (fermeture des modales lors du chargement, puis réouverture des modales. )

  useEffect(() => {
    if (isEmpty(absenceTypes)) getAbsenceTypes();
  }, [absenceTypes]);

  useEffect(() => {
    let filters = createFilters();
    fetchAttendances(filters);
  }, [rangeDate, userId]);

  // useEffect(() => {
  //   const pContainer = document.getElementById("p-container-id");
  //   pContainer.style.overflow = "visible";
  //   getAbsenceTypes();
  //   return () => (pContainer.style.overflow = "auto");
  // }, []);

  const displayErrors = (errorTitle, contentError) => {
    Modal.error({
      title: errorTitle,
      content: contentError
    });
  };

  const createFilters = () => {
    const filters = { user_id: userId };
    if (Array.isArray(rangeDate) && rangeDate.length === 2) {
      const startDate = rangeDate[0];
      const endDate = rangeDate[1];
      filters.start_date = startDate;
      filters.end_date = endDate;
    }
    setFilters(filters);
    return filters;
  };

  useEffect(() => {
    setBadgeFactory(_badgeFactory);
  }, [_badgeFactory.begin, _badgeFactory.end]);

  usePresenceChanges(
    detailsDay,
    "updateMealPackageErrors",
    setErrorModalData,
    "Forfait repas",
    resetMealPackageErrors,
    setIsErrorModalOpen
  );
  usePresenceChanges(detailsDay, "updateTripErrors", setErrorModalData, "Trajet", resetTripErrors, setIsErrorModalOpen);
  usePresenceChanges(
    detailsDay,
    "updateAttendanceErrors",
    setErrorModalData,
    "Présence",
    resetAttendanceErrors,
    setIsErrorModalOpen
  );

  useEffect(() => {
    if (detailsDay) {
      setDays(detailsDay.get("userData"));
      parseData(detailsDay.get("userData"));
    }
    if (detailsDay.get("userName")) setUserName(detailsDay.get("userName"));
    if (detailsDay.get("userRoleId")) setUserDetailRole(detailsDay.get("userRoleId"));
  }, [detailsDay]);

  const fetchAttendances = filters => {
    fetchDetailsDay(filters);
  };

  const openTripsModal = content => {
    setModal("map");
    setSelectedModalData(content);
    setModalOpen(true);
  };

  const openPresenceModal = content => {
    setModalOpen(true);
    setSelectedModalData(content);
    setSelectedDayData(content);
    setModal("presence");
  };

  const openMealPackageModal = content => {
    setModalOpen(true);
    setSelectedModalData(content);
    setSelectedDayData(content);
    setModal("mealPackage");
  };

  const parseData = data => {
    let day = badgeFactory.separateCategories(data);

    let presenceBadges = badgeFactory.parsePresence(day.dataDay);
    let tripBadges = badgeFactory.parseTrips(day.trips);
    let activityBadges = badgeFactory.parseActivity(day.activities);

    const { begin, end } = computeGridEnds(activityBadges);
    _badgeFactory.updateBeginAndEndHour(begin, end);

    setChartData({
      presence: presenceBadges,
      trips: tripBadges,
      activity: activityBadges
    });
  };

  const modifyTrip = trip => {
    updateTrip(trip);
    setModalOpen(false);
  };

  const onCloseErrorModal = () => {
    console.log("onCloseErrorModal : ", onCloseErrorModal);
  };

  const handleGrantMealPackage = async () => {
    const payload = {
      _id: mealPackageSelected[0]._id,
      granted: mealPackageModalValue,
      index: selectedDayData.index
    };

    setIsMealPackageLoading(true);
    setDidErrorOccured(false);
    updateMealPackage(payload);
    setModalOpen(false);
    setIsMealPackageLoading(false);
  };

  const modalContentSelector = modal => {
    if (modal === "mealPackage")
      return (
        <ProcessMealPackage
          errorMsg={errorMsg}
          onClick={() => handleGrantMealPackage()}
          mealPackageModalValue={mealPackageModalValue}
          didErrorOccured={didErrorOccured}
          handleGrantMealPackage={handleGrantMealPackage}
          setMealPackageModalValue={setMealPackageModalValue}
        />
      );
    if (modal === "map") return <MapModal modifyTrip={modifyTrip} data={selectedModalData} />;
    if (modal === "presence") {
      if (computeTypeOfHalfDay(selectedDayData, "morning") === VACATION_REQUEST_STATUS_LABELS.PENDING) {
        const eventInfos = computeEventInfos(selectedDayData, "morning");
        return (
          <ValidateModalContent
            selectedUserBalance={selectedUserBalance}
            eventInfos={eventInfos}
            accept={vacation => {
              accept({ vacation: { _id: vacation._id } });
            }}
            reject={vacation => {
              reject({ vacation: { _id: vacation._id } });
            }}
            closeModal={() => {
              setModalOpen(false);
              setTimeout(() => {
                getPresenceDataOfTheDay({
                  start_date: selectedDayData.pending_vacations.morning.start_date,
                  end_date: selectedDayData.pending_vacations.morning.end_date
                });
              }, 1000); // Solution temporaire pour laisser du temps au back de mettre à jour le temps de faire l'update directement du front une fois retour du back reçu.
            }}
          />
        );
      } else if (computeTypeOfHalfDay(selectedDayData, "afternoon") === VACATION_REQUEST_STATUS_LABELS.PENDING) {
        const eventInfos = computeEventInfos(selectedDayData, "afternoon");
        return (
          <ValidateModalContent
            selectedUserBalance={selectedUserBalance}
            eventInfos={eventInfos}
            accept={vacation => {
              accept({ vacation: { _id: vacation._id } });
            }}
            reject={vacation => {
              reject({ vacation: { _id: vacation._id } });
            }}
            closeModal={() => {
              setModalOpen(false);
              setTimeout(() => {
                getPresenceDataOfTheDay({
                  start_date: selectedDayData.pending_vacations.afternoon.start_date,
                  end_date: selectedDayData.pending_vacations.afternoon.end_date
                });
              }, 1000); // Solution temporaire pour laisser du temps au back de mettre à jour le temps de faire l'update directement du front une fois retour du back reçu.
            }}
          />
        );
      } else {
        return (
          <PresenceModal
            updateAttendance={updateAttendance}
            userRoleId={userRoleId}
            absenceTypes={absenceTypes}
            token={token}
            attendance={selectedDayData.attendances}
            indexSelected={selectedDayData.index}
            visits={selectedDayData.visits}
            closeModal={() => {
              setModalOpen(false);
            }}
          />
        );
      }
    }
  };
  const Header = () => (
    <tr>
      <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider w-1/12">
        Date
      </th>
      <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider w-2/12">
        Activité
      </th>
      <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider w-1/12">
        Nombre
      </th>
      <th className="px-6 py-3 border-b border-gray-200 leading-4 font-medium text-gray-800 tracking-wider text-right w-2/3">
        <Grid begin={badgeFactory.begin} end={badgeFactory.end} />
      </th>
    </tr>
  );

  return (
    <div className="flex flex-col my-8 overflow-y-scroll" style={{ height: "calc(100vh - 255px)", paddingRight: 30 }}>
      <div className="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 overflow-x-scroll">
        <div className="align-middle inline-block min-w-full shadow sm:rounded-lg border-b border-gray-200">
          <table className="min-w-full">
            <thead>
              <Header />
            </thead>
            {chartData.activity ? (
              <tbody className="bg-white">
                {days.map((day, index) => {
                  const date = day.date || "";
                  const isMonday = date.indexOf("lundi") > -1;
                  return (
                    <Fragment key={index}>
                      {isMonday && index !== 0 && <Header />}

                      <DayRow
                        userDetailsRole={userDetailsRole}
                        userRoleId={userRoleId}
                        driverId={userId}
                        driverName={userName}
                        isMealPackageLoading={isMealPackageLoading}
                        setMealPackageModalValue={setMealPackageModalValue}
                        setMealPackageSelected={setMealPackageSelected}
                        day={day}
                        token={token}
                        index={index}
                        openPresenceModal={openPresenceModal}
                        openTripsModal={openTripsModal}
                        openMealPackageModal={openMealPackageModal}
                        badgeFactory={badgeFactory}
                        history={history}
                        chartData={chartData}
                      />
                    </Fragment>
                  );
                })}
              </tbody>
            ) : null}
          </table>
        </div>
        {isLoading && (
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 100
            }}
          >
            <Spin />
          </div>
        )}
      </div>
      <Modal
        title={errorModalData && errorModalData.title}
        visible={isErrorModalOpen}
        onOk={() => errorModalData.afterClose()}
      >
        {errorModalData && errorModalData.content}
      </Modal>
      <ModalComponent
        title={selectedModalData.title}
        width={700}
        showModal={modalOpen}
        closeModal={() => {
          setDidErrorOccured(false);
          setModalOpen(!modalOpen);
        }}
      >
        {modalContentSelector(modal)}
      </ModalComponent>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userRoleId: state.userInfos.role_id,
    token: state.auth.token,
    absenceTypes: state.absenceTypes.filter(aT => aT.absence),
    selectedUserBalance: state.presence.selectedUserBalance || {},
    detailsDay: state.presenceDetailsDay
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAbsenceTypes: () => dispatch(getAbsenceTypes()),
    reject: payload => {
      dispatch(rejectVacation(payload));
    },
    accept: payload => {
      dispatch(validateVacation(payload));
    },
    fetchDetailsDay: payload => dispatch(getPresenceDetailsDay(payload)),
    updateAttendance: payload => dispatch(updatePresenceAttendance(payload)),
    updateMealPackage: payload => dispatch(updatePresenceMealPackage(payload)),
    resetMealPackageErrors: () => dispatch(resetPresenceMealPackage()),
    updateTrip: payload => dispatch(updatePresenceTrip(payload)),
    resetTripErrors: () => dispatch(resetPresenceTrip()),
    resetAttendanceErrors: () => dispatch(resetPresenceAttendance()),
    getPresenceDataOfTheDay: payload => dispatch(getPresenceDataOfTheDay(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DayView));



// WEBPACK FOOTER //
// src/modules/presence/presence/DayView.js